// extracted by mini-css-extract-plugin
export default {"sectionNameType":"Q-CsP5Y3FT","loadingDot":"_3GL3LmFL_E","dot2":"uZWMZR9nBW","dot1":"saNygeIhRC","dot3":"_3RtxWfV4g4"};